module.exports = __webpack_public_path__ + "0373d6ef33660bbc098d2b2f070dc829.pdf";